exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget .block-title {\n  border-bottom: 2px solid #1c1c1c;\n  font-size: 14px;\n  line-height: 100%;\n  margin: 0 0 40px;\n  text-transform: uppercase;\n}\n.widget .block-title span {\n  background: #1c1c1c;\n  color: #fff;\n  height: 30px;\n  line-height: 30px;\n  padding: 8px 15px;\n  position: relative;\n}\n.widget .block-title span:after {\n  border-color: #272727 rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0);\n  position: absolute;\n  content: \" \";\n  width: auto;\n  height: auto;\n  bottom: -20px;\n  margin-left: -10px;\n  left: 50%;\n  border-width: 10px;\n  border-style: solid;\n}", ""]);

// exports
